import mapValues from 'lodash/mapValues'

export enum FeatureFlagName {
  NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS = 'NEXT_PUBLIC_TOGGLE_WHATS_ON_DECK_FILTERS',
  NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE = 'NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE',
  NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING = 'NEXT_PUBLIC_FEAT_FLAG_GIFT_CARD_LANDING',
  NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY = 'NEXT_PUBLIC_FEAT_FLAG_EVENT_NOTY',
  NEXT_PUBLIC_FEAT_FLAG_CONTENT_BLOCK = 'NEXT_PUBLIC_FEAT_FLAG_CONTENT_BLOCK',
  NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT = 'NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT',
  NEXT_PUBLIC_FEAT_FLAG_WEVO = 'NEXT_PUBLIC_FEAT_FLAG_WEVO',
}

export type FeatureFlags = { [key in FeatureFlagName]: boolean }

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = mapValues(
  FeatureFlagName,
  () => false
)
